
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 44 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"44","height":"44","rx":"20","fill":"#00AEEF"}}),_c('path',{attrs:{"d":"M21.999 22.75a5.256 5.256 0 005.25-5.25 5.256 5.256 0 00-5.25-5.25 5.256 5.256 0 00-5.25 5.25 5.256 5.256 0 005.25 5.25zm0-9a3.754 3.754 0 013.75 3.75 3.754 3.754 0 01-3.75 3.75 3.754 3.754 0 01-3.75-3.75 3.754 3.754 0 013.75-3.75zm7.75 14.217v1.011a3.77 3.77 0 01-.961 2.522.746.746 0 01-1.06.059.75.75 0 01-.057-1.059c.373-.417.579-.957.579-1.521v-1.011c0-1.514-1.004-2.824-2.443-3.185a1.02 1.02 0 00-.746.096 6.308 6.308 0 01-6.116.003 1.009 1.009 0 00-.751-.1c-1.439.362-2.444 1.672-2.444 3.186v1.011c0 .565.206 1.105.579 1.521a.75.75 0 01-1.117 1.001 3.773 3.773 0 01-.961-2.522v-1.011c0-2.202 1.47-4.11 3.577-4.64a2.525 2.525 0 011.854.248 4.799 4.799 0 004.644-.003 2.529 2.529 0 011.849-.244c2.103.527 3.574 2.435 3.574 4.638z","fill":"#fff"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/lk/img/User.svg